import React from "react";
import Viewer from "../viewer/Viewer";
import Props from "../properties/Properties";
import DataProperties from "../dataProperties/DataProperties";
import Reports from "../reports/Reports";
import Calculations from "../calculations/Calculations";
import MetaProperties from "../meta-properties/MetaProperties";
import { connect } from "react-redux";
import SplitPane, { Pane } from "react-split-pane";
import {
  getSelectedModelArray,
  updateStatPropValues,
  updateDynaPropValues,
  updateMetaProp,
  updateSelectedTag,
  updateAdditionalTabs,
  updateWorkflowState,
  getReviewId,
  getSelectedModel,
  updateMarkupState,
  updateMarkupTitle,
  updateMarkupReviewerId,
  update,
} from "../../helpers/actions/Action";
import store from "../../helpers/store/Store";
import Markdown from "react-markdown";
import axios from "axios";
import { HOST_URL } from "../../helpers/constants/Constants";
import Markups from "../viewer/Markups";
import MarkupPanel from "../viewer/MarkupPanel";
import PdfPanel from "../viewer/PdfPanel";
import WorkFlowPanel from "../viewer/WorkflowPanel";
import Select from "react-select";
import makeAnimated from "react-select/animated";

class ToolbarViewerController extends React.Component {
  animatedComponents = makeAnimated();
  userDropDownData = null;
  constructor(props) {
    super(props);

    this.state = {
      showMarkup: false,
      showWorkflow: false,
      showPdf: false,
      showData: false,
      showUpload: false,
      showReports: false,
      showCalculations: false,
      showMetaProperties: false,
      showViewer: false,
      showStartText: true,
      currentShown: false,
      isMobile: false,
      isTablet: false,
      size: null,
      comment: "",
      reviewing:true,
    };
  }

  changeView = (show, e) => {
    const navItems = [
      "showMarkup",
      "showData",
      "showUpload",
      "showWorkflow",
      "showReports",
      "showCalculations",
      "showMetaProperties",
      "showPdf",
    ];
    let previouslyShown = "";
    for (let key in this.state) {
      if (this.state[key] === true) {
        previouslyShown = key;
      }

      if (key !== "currentShown" && key !== "size") {
        this.setState({
          [key]: false,
        });
      }
    }
    const pane1 = document.querySelector(".Pane1");
    if (
      show !== previouslyShown &&
      navItems.includes(show) &&
      !this.state.isMobile
    ) {
      this.setState({
        [show]: true,
      });
      pane1.style.width = this.calculatePaneWidth() + "px";
    } else if (
      show !== previouslyShown &&
      navItems.includes(show) &&
      this.state.isMobile
    ) {
      pane1.style.width = this.calculatePaneWidth(true) + "px";
    } else {
      pane1.style.width = this.calculatePaneWidth(true) + "px";
    }
  };

  nameShortening = (text) => {
    let maxLength = this.props.settings.maxTabNameLength;
    let shortendName =
      text.length >= maxLength ? text.substring(0, maxLength) + "..." : text;
    return <span> {shortendName} </span>;
  };

  calculatePaneWidth = (fullWidth = false) => {
    const sectionWidth = !this.props.show
      ? window.innerWidth
      : window.innerWidth - 340;
    if (fullWidth) {
      return sectionWidth;
    } else {
      return sectionWidth * 0.6;
    }
  };

  onResize = (self) => {
    if (window.event !== undefined && window.event.isTrusted) {
      const pane1 = document.querySelector(".Pane1");
      if (
        (self.state.showMarkup ||
          self.state.showWorkflow ||
          self.state.showPdf ||
          self.state.showData ||
          self.state.showUpload ||
          self.state.showReports ||
          self.state.showCalculations ||
          self.state.showMetaProperties) &&
        !this.state.isMobile
      ) {
        pane1.style.width = self.calculatePaneWidth() + "px";
      } else if (
        (self.state.showMarkup ||
          self.state.showWorkflow ||
          self.state.showPdf ||
          self.state.showData ||
          self.state.showUpload ||
          self.state.showReports ||
          self.state.showCalculations ||
          self.state.showMetaProperties) &&
        this.state.isMobile
      ) {
        pane1.style.width = this.calculatePaneWidth(true) + "px";
      } else {
        pane1.style.width = self.calculatePaneWidth(true) + "px";
      }
    }
  };

  resizeWindow = (size) => {
    if (window.document.documentMode) {
      let resizeEvent = window.document.createEvent("UIEvents");
      resizeEvent.initUIEvent("resize", true, false, window, 0);
      window.dispatchEvent(resizeEvent);
    } else {
      window.dispatchEvent(new Event("resize"));
    }
    if (this.state.size !== size && size !== undefined) {
      this.setState({
        size: size,
      });
    }
  };

  onHeaderClick = (e, model) => {
    if (!e.target.classList.contains("icon-close-tab")) {
      this.setState({
        currentShown: model.id,
      });
      let array = this.props.modelArray.map((obj) => {
        if (obj.id === model.id) {
          obj.selected = true;
        } else {
          obj.selected = false;
        }
        return obj;
      });

      store.dispatch(getSelectedModelArray(array));
      if (document.getElementById("pushpin-toggle-tooltip-" + model.id) != null)
        document.getElementById(
          "pushpin-toggle-tooltip-" + model.id
        ).innerHTML = "Show/Hide issues";

      //this.saveTabData();
      this.loadTabsData(model.name);
    }
  };
  selectanimatedComponents;

  loadTabsData = (fileName) => {
    // var formDataTabs = new FormData()
    // formDataTabs.append("FileName",fileName)

    // axios({
    //   method: "post",
    //   url: HOST_URL + `/api/gettabdata`,
    //   data: formDataTabs,
    //   headers: {
    //     "Content-Type": "multipart/form-data"
    //   }
    // })
    // .then((response)=>{
    //   store.dispatch(updateDynaPropValues(response.data.DynaPropValues));
    //   store.dispatch(updateStatPropValues(response.data.StatPropValues));
    //   store.dispatch(updateMetaProp([response.data.ElementWithProperties, response.data.Categories, true]));
    //   store.dispatch(updateSelectedTag(""));
    // })
    // .catch((error) => {
    //   store.dispatch(updateDynaPropValues([]));
    //   store.dispatch(updateStatPropValues([]));
    //   store.dispatch(updateMetaProp([[], [], false]));
    //   store.dispatch(updateSelectedTag(""));
    // })

    if (JSON.parse(window.sessionStorage.getItem(fileName)) === null) {
    } else {
      var tabData = JSON.parse(window.sessionStorage.getItem(fileName));
      store.dispatch(updateDynaPropValues(JSON.parse(tabData.DynaPropValues)));
      store.dispatch(updateStatPropValues(JSON.parse(tabData.StatPropValues)));
      store.dispatch(
        updateMetaProp([
          JSON.parse(tabData.ElemWithProps),
          JSON.parse(tabData.Categories),
          true,
        ])
      );
      store.dispatch(updateSelectedTag(""));
    }
  };

  onHeaderClose = (model) => {
    // console.log("Markup State on Close = ",this.props.markupState)
    // if (this.props.markupState!="exit"||this.props.markupState!="save"){
    //   if (window.confirm("Are you sure you want to exit? All unsaved markups will be lost") != true){
    //     return;
    //   }
    // }

    store.dispatch(updateAdditionalTabs(true));
    let array = this.props.modelArray.filter(function (obj) {
      return obj.id !== model.id;
    });
    let int = this.props.modelArray.findIndex((obj) => obj.id === model.id) + 1;
    if (
      model.selected &&
      this.props.modelArray.length > 1 &&
      int !== this.props.modelArray.length
    ) {
      array.map((view) => {
        if (
          view.id ===
          this.props.modelArray[
            this.props.modelArray.findIndex((obj) => obj.id === model.id) + 1
          ].id
        ) {
          view.selected = true;
        }
        return view;
      });
    } else if (
      model.selected &&
      this.props.modelArray.length > 1 &&
      int === this.props.modelArray.length
    ) {
      array.map((view) => {
        if (
          view.id ===
          this.props.modelArray[
            this.props.modelArray.findIndex((obj) => obj.id === model.id) - 1
          ].id
        ) {
          view.selected = true;
        }
        return view;
      });
    } else if (model.selected) {
      array.map((view, i) => {
        if (i === 0) {
          view.selected = true;
        }
        return view;
      });
    }
    store.dispatch(getSelectedModelArray(array));
  };

  componentDidMount() {
    let self = this;
    window.addEventListener("resize", function () {
      self.onResize(self);
    });
    if (window.screen.width <= this.props.settings.mobileWidth) {
      this.setState({
        isMobile: true,
      });
    } else if (window.screen.width <= this.props.settings.tabletWidth) {
      this.setState({
        isTablet: true,
      });
    }
  }

  // componentDidUpdate(prevProps, prevState) {
  //   console.log("Hit & state=", this.props.markupState);
  //   if (this.props.markupState === "save") {
  //     if (this.props.isMetaPropDataLoaded) {
  //       this.changeView("showMarkup");
  //     } else {
  //       if (this.state.showMetaProperties) this.changeView("showMarkup");
  //       alert("Please open a model first to view the associated markups");
  //     }
  //   }
  // }

  componentDidUpdate(prevProps, prevState) {
    this.resizeWindow();
    if (this.props.modelArray.length !== 0 && this.state.showStartText) {
      this.changeView("showViewer");
    } else if (
      this.props.modelArray.length === 0 &&
      !this.state.showStartText &&
      !this.state.showMarkup &&
      !this.state.showWorklow &&
      !this.state.showPdf &&
      !this.state.showData &&
      !this.state.showUpload &&
      !this.state.showReports &&
      !this.state.showCalculations &&
      !this.state.showMetaProperties
    ) {
      this.setState({
        showMarkup: false,
        showWorkflow: false,
        showPdf: false,
        showData: false,
        showUpload: false,
        showReports: false,
        showCalculations: false,
        showMetaProperties: false,
        showViewer: false,
        showStartText: true,
      });
    }
    if (!this.props.selectedProject.projectid) {
      return;
    }
    console.log("selectedProject", this.props.selectedProject);
    axios({
      method: "Get",
      url:
        HOST_URL +
        "/api/forge/bim360/Users?projectid=" +
        this.props.selectedProject.projectid,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      withCredentials: true,
    })
      .then((response) => {
        var tempData = [];
        response.data.results.forEach((user) => {
          var user = {
            value: `${user.autodeskId}-${user.email}-${user.firstName} ${user.lastName}`,
            label: `${user.firstName} ${user.lastName} - ${user.email}`,
          };
          tempData.push(user);
        });
        console.log("Users For Markup  -", tempData);
        this.userDropDownData = tempData;
      })
      .catch((error) => {
        console.log(error);
      });
  }

  onMetaPropButtonClick = (e) => {
    if (this.props.isMetaPropDataLoaded) {
      this.changeView("showMetaProperties", e);
    } else {
      if (this.state.showMetaProperties)
        this.changeView("showMetaProperties", e);
      alert("No data to be loaded");
    }
  };

  onLoadMarkupsButtonClick = (e) => {
    if (this.props.isMetaPropDataLoaded) {
      this.changeView("showMarkup", e);
    } else {
      if (this.state.showMetaProperties) this.changeView("showMarkup", e);
      alert("Please open a model first to view the associated markups");
    }
  };

  onLoadPdfButtonClick = (e) => {
    this.changeView("showPdf", e);
  };

  onWorkflowButtonClick = (e) => {
    // store.dispatch(updateWorkflowState("true"));
    this.changeView("showWorkflow", e);

    if (this.props.isMetaPropDataLoaded) {
      this.changeView("showWorkflow", e);
    } else {
      if (this.state.showMetaProperties) this.changeView("showWorkflow", e);
      alert("Please open a model first before initiating workflows");
    }
  };

  buttons = () => {
    console.log("reviewId - ", this.props.reviewId);
    console.log("this.state.reviewing!=true ",this.state.reviewing)
    console.log(
      "Selected Review - ",
      this.props.modelArray?.filter((o) => o.selected == true)[0]?.id
    );
    const {
      showWorkflow,
      showMarkup,
      showData,
      showUpload,
      showReports,
      showCalculations,
      showMetaProperties,
    } = this.state;
    if (
      typeof this.props.selected === "object" &&
      !this.state.isMobile &&
      !this.state.isTablet
    ) {
      return (
        <div id="theToolbar">
          <div>
            <ul className="nav nav-pills">
              {this.renderHeader(
                this.props.modelArray,
                this.state.currentShown
              )}
            </ul>
          </div>
          <div>
            <nav className="btn-group d-none d-lg-block">
              {/* <button
                type="button"
                className={`btn btn-secondary btn-sm ${
                  showMarkup ? "active" : ""
                }`}
                onClick={this.onLoadMarkupsButtonClick}
              >
                Markups panel
              </button> */}
              {/* <button
                type="button"
                className={`btn btn-secondary btn-sm ${
                  showWorkflow ? "active" : ""
                }`}
                onClick={(e) => this.onWorkflowButtonClick()}>
                Workflow Panel
              </button> */}

              {/* <button
                type="button"
                className={`btn btn-secondary btn-sm ${
                  showMarkup ? "active" : ""
                }`}
                onClick={this.onLoadPdfButtonClick}
              >
                Pdf panel
              </button> */}

              <button
                type="button"
                className={`btn btn-secondary btn-sm ${
                  showUpload ? "active" : ""
                }`}
                onClick={(e) => this.changeView("showUpload", e)}>
                Upload
              </button>

              <button
                type="button"
                className={`btn btn-secondary btn-sm ${
                  showData ? "active" : ""
                }`}
                onClick={(e) => this.changeView("showData", e)}>
                Project data
              </button>
              {/* <button
                type="button"
                className={`btn btn-secondary btn-sm ${
                  showReports ? "active" : ""
                }`}
                onClick={(e) => this.changeView("showReports", e)}
              >
                Reports
              </button> */}
              <button
                type="button"
                className={`btn btn-secondary btn-sm ${
                  showCalculations ? "active" : ""
                }`}
                onClick={(e) => this.changeView("showCalculations", e)}>
                Calculations
              </button>
              <button
                type="button"
                className={`btn btn-secondary btn-sm ${
                  showMetaProperties ? "active" : ""
                }`}
                onClick={this.onMetaPropButtonClick}>
                Automatic Documentation
              </button>

              {this.props.reviewId != null && 
              this.props.modelArray
                ?.filter((o) => o.selected == true)
                .find((o) => o.id === this.props.docId) != null ? (
                <button
                  value={this.props.reviewId}
                  type="button"
                  className="btn btn-primary btn-sm ml-2"
                  data-toggle="modal"
                  data-target="#workflowModal"
                  disabled={this.state.reviewing}
                  >
                  Review
                </button>
              ) : (
                <></>
              )}

              {this.props.approvalId != null && 
              this.props.modelArray
                ?.filter((o) => o.selected == true)
                .find((o) => o.id === this.props.docId) != null ? (
                <button
                  value={this.props.approvalId}
                  type="button"
                  className="btn btn-primary btn-sm ml-2"
                  data-toggle="modal"
                  data-target="#workflowModal"
                  disabled={this.state.reviewing}
                  >
                  Approve
                </button>
              ) : (
                <></>
              )}
            </nav>
          </div>
        </div>
      );
    } else {
      return <div id="theToolbar"></div>;
    }
  };

  welcomeText = () => {
    return (
      <div className="d-center">
        <Markdown source={this.props.startpageText} />
      </div>
    );
  };

  renderHeader = (models) =>
    models.map((model, i) => {
      let id = "theProjectViewerHeader-" + model.id;
      let active = model.selected ? "active" : "";

      return (
        <li className="nav-item" id={id} key={model.id + "-tab"}>
          <button
            className={`nav-link ${active}`}
            onClick={(e) => this.onHeaderClick(e, model)}
            title={model.name}>
            <span>{this.nameShortening(model.name)}</span>
            <span
              className="close ml-2 icon-close-tab"
              onClick={(e) => this.onHeaderClose(model)}
            />
          </button>
        </li>
      );
    });

  renderViewer = (models) =>
    models.map((model, i) => {
      let id = "theProjectViewer-" + model.id;
      let show = model.selected ? "d-block" : "hide";

      return (
        <div
          className={`theProjectViewer ${show}`}
          id={id}
          key={model.id + "-viewer"}>
          <Props id={model.id} />
          <Viewer urn={"urn:" + model.id} id={model.id} model={model} />
        </div>
      );
    });
  commentInputHandler = (e) => {
    this.state.comment = e.target.value;
  };

  handleReviewButtonClick = (e, status) => {
    this.setState({reviewing: true});
    console.log("this.state.reviewing ",this.state.reviewing);
    console.log(this.props.reviewId);
    console.log(this.props.userData.id);
    console.log(this.state.comment);
    if (this.props.reviewId) {
      let formData = new FormData();
      formData.append(
        "formData",
        JSON.stringify({
          id: this.props.reviewId,
          userId: this.props.userData.id,
          comment: this.state.comment,
          status: status,
        })
      );
      axios({
        method: "Put",
        url: HOST_URL + "/api/workflow/UpdateReviewers",
        data: formData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        withCredentials: true,
      })
        .then((response) => {
          console.log(response);
          this.state.reviewing = false;
          alert("Workflow has been updated");
          store.dispatch(update("reviewId", null));
          store.dispatch(getSelectedModel(""));
          store.dispatch(getSelectedModelArray([]));

          console.log(this.props.reviewId);
        })
        .catch((error) => {
          console.log(error);
        });
    }

    if (this.props.approvalId) {
      let formData = new FormData();
      formData.append(
        "formData",
        JSON.stringify({
          id: this.props.approvalId,
          userId: this.props.userData.id,
          comment: this.state.comment,
          status: status,
        })
      );
      axios({
        method: "Put",
        url: HOST_URL + "/api/workflow/UpdateApprovers",
        data: formData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        withCredentials: true,
      })
        .then((response) => {
          console.log(response);
          alert("Workflow has been updated");
          store.dispatch(update("approvalId", null));
          store.dispatch(getSelectedModel(""));
          store.dispatch(getSelectedModelArray([]));

          console.log(this.props.reviewId);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  titleInputHandler = (e) => {
    store.dispatch(updateMarkupTitle(e.target.value));
  };

  markupReviewerInputHandler = (e) => {
    store.dispatch(updateMarkupReviewerId(e.value));
  };

  createButtonClick = (e) => {
    store.dispatch(updateMarkupState("save"));
  };

  renderModals = () => {
    return (
      <div>
        <div
          className="modal fade"
          id="workflowModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="workflowModalLabel"
          aria-hidden="true">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="workflowModalLabel">
                  Complete Review
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-2">
                    <label>Reviewer Comment</label>
                  </div>
                  <div className="col">
                    <textarea
                      className="form-control"
                      type="text"
                      id="workflowInput"
                      placeholder="Comment"
                      rows="10"
                      onChange={this.commentInputHandler}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  value={this.reviewerId}
                  className="btn btn-success p-2"
                  onClick={(e) => this.handleReviewButtonClick(e, "Approved")}
                  data-dismiss="modal"
                  >
                  Approve
                </button>
                <button
                  value={this.reviewerId}
                  className="btn btn-danger p-2"
                  onClick={(e) => this.handleReviewButtonClick(e, "Rejected")}
                  data-dismiss="modal"
                  >
                  Reject
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="createModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="createModalLabel"
          aria-hidden="true">
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="creatModalLabel">
                  Create Markup
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-2">
                    <label>Title</label>
                  </div>
                  <div className="col">
                    <input
                      className="form-control"
                      type="text"
                      id="workflowInput"
                      placeholder="Title"
                      onChange={this.titleInputHandler}
                    />
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-2">
                    <label>Reviewer</label>
                  </div>
                  <div className="col">
                    <Select
                      closeMenuOnSelect={false}
                      components={this.animatedComponents}
                      defaultValue={[]}
                      // isMulti
                      options={this.userDropDownData}
                      onChange={this.markupReviewerInputHandler}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-success p-2"
                  onClick={this.createButtonClick}
                  data-dismiss="modal">
                  Create
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal">
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      showStartText,
      showMarkup,
      showWorkflow,
      showData,
      showUpload,
      showReports,
      showCalculations,
      showMetaProperties,
    } = this.state;
    this.resizeWindow();
    return (
      <>
        {this.buttons()}
        <section
          className={`start-hero ${showStartText ? "d-block" : "d-none"}`}>
          {this.welcomeText()}
        </section>
        <section className={showStartText ? "d-none" : "d-block"}>
          <SplitPane
            split="vertical"
            onChange={(size) => this.resizeWindow(size)}>
            <Pane className="d-block">
              {this.renderViewer(this.props.modelArray)}
            </Pane>
            <Pane className="d-block theWestSide">
              {/* <Markups /> */}
              <div
                className={
                  this.props.markupState === "open" ? "d-block" : "d-none"
                }>
                <MarkupPanel size={this.state.size} show={this.props.show} />
              </div>
              <div
                className={
                  this.props.pdfState === "true" ? "d-block" : "d-none"
                }>
                <PdfPanel size={this.state.size} show={this.props.show} />
              </div>

              <div className={showWorkflow ? "d-block" : "d-none"}>
                <WorkFlowPanel size={this.state.size} show={this.props.show} />
              </div>

              <div className={showUpload ? "d-block" : "d-none"}>
                <WorkFlowPanel size={this.state.size} show={this.props.show} />
              </div>
              <div className={showData ? "d-block" : "d-none"}>
                <DataProperties size={this.state.size} show={this.props.show} />
              </div>
              <div className={showReports ? "d-block" : "d-none"}>
                <Reports size={this.state.size} show={this.props.show} />
              </div>
              <div
                id="calculations"
                className={showCalculations ? "d-block" : "d-none"}>
                <Calculations size={this.state.size} show={this.props.show} />
              </div>
              <div className={showMetaProperties ? "d-block" : "d-none"}>
                <MetaProperties size={this.state.size} show={this.props.show} />
              </div>
            </Pane>
          </SplitPane>
        </section>
        {this.renderModals()}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  userData: state.requestUserDataReducer.data,
  data: state.requestModelDataReducer.data,
  selectedModel: state.getSelectedModelReducer.data,
  selected: state.getSelectedProjectReducer.data,
  docId: state.getPersonalHubReducer.docId,
  reviewId: state.getPersonalHubReducer.reviewId,
  approvalId: state.getPersonalHubReducer.approvalId,
  modelArray: state.getModelArrayReducer.data,
  startpageText: state.getMarkdown.data,
  settings: state.requestGeneralSettingsReducer.data,
  isMetaPropDataLoaded: state.metaPropReducer.isMetaPropDataLoaded,
  markupState: state.markupStateReducer.markupState,
  pdfState: state.pdfStateReducer.pdfState,
  workflowState: state.workflowStateReducer.workflowState,
  //selectedModel: state.getSelectedModelReducer.data,
  elemWithProperties: state.metaPropReducer.elementWithProperties,
  categories: state.metaPropReducer.categories,
  dynaPropValues: state.metaPropReducer.dynaPropValues,
  statPropValues: state.metaPropReducer.statPropValues,
  selectedProject: state.getSelectedProjectReducer.data,
});

export default connect(mapStateToProps)(ToolbarViewerController);
